import React from "react";
import  "./FetchLatestAiFeedbackPopUp.scss";
import { NEW_FEEDBACKS_NOTIFICATION } from "../../../../constant";


const FetchLatestAiFeedbackPopUp = ({getCachedFeedbacks , handlePopUpClose}) => {


  return (<div id="pop-up-dialog">
            <p>{NEW_FEEDBACKS_NOTIFICATION}</p>
            <div id="pop-up-dialog-buttons">
                <button onClick={() => handlePopUpClose()}>No</button> 
                <button onClick={() => getCachedFeedbacks()} >Yes</button>
            </div>
  </div>);
   
}
export default FetchLatestAiFeedbackPopUp;
